// Wrap every letter in a span
$('.text-wrapper .letters:not(.letters-1)').removeClass('hide');
$('.ml4 .letters').each(function(){
    $(this).html($(this).text().replace(/([^\x80-\xFF]|[À-ÖØ-öø-ÿ]|\w)/g, "<span class='letter letter-$&'>$&</span>"));
});

anime.timeline({loop: true})
    .add({
        targets: '.letters-1 .letter',
        translateY: ["1.1em", 0],
        translateX: ["0.55em", 0],
        translateZ: 0,
        rotateZ: [180, 0],
        duration: 750,
        easing: "easeOutExpo",
        delay: function(el, i) {
            return 50 * i;
        }
    }).add({
    targets: '.letters-1',
    opacity: 0,
    duration: 1000,
    easing: "easeOutExpo",
    delay: 800
}).add({
    targets: '.letters-2 .letter',
    translateY: ["1.1em", 0],
    translateX: ["0.55em", 0],
    translateZ: 0,
    rotateZ: [180, 0],
    duration: 750,
    easing: "easeOutExpo",
    delay: function(el, i) {
        return 50 * i;
    }
}).add({
    targets: '.letters-2',
    opacity: 0,
    duration: 1000,
    easing: "easeOutExpo",
    delay: 800
}).add({
    targets: '.letters-3 .letter',
    translateY: ["1.1em", 0],
    translateX: ["0.55em", 0],
    translateZ: 0,
    rotateZ: [180, 0],
    duration: 750,
    easing: "easeOutExpo",
    delay: function(el, i) {
        return 50 * i;
    }
}).add({
    targets: '.letters-3',
    opacity: 0,
    duration: 1000,
    easing: "easeOutExpo",
    delay: 800
}).add({
    targets: '.letters-4 .letter',
    translateY: ["1.1em", 0],
    translateX: ["0.55em", 0],
    translateZ: 0,
    rotateZ: [180, 0],
    duration: 750,
    easing: "easeOutExpo",
    delay: function(el, i) {
        return 50 * i;
    }
}).add({
    targets: '.letters-4',
    opacity: 0,
    duration: 1000,
    easing: "easeOutExpo",
    delay: 800
}).add({
    targets: '.letters-5 .letter',
    translateY: ["1.1em", 0],
    translateX: ["0.55em", 0],
    translateZ: 0,
    rotateZ: [180, 0],
    duration: 750,
    easing: "easeOutExpo",
    delay: function(el, i) {
        return 50 * i;
    }
}).add({
    targets: '.letters-5',
    opacity: 0,
    duration: 1000,
    easing: "easeOutExpo",
    delay: 800
});
